import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles(theme => ({
	mainContainer: {
		flex: 1,
		padding: "var(--page-padding-top) var(--page-padding-x) var(--page-padding-bottom)",
		height: `calc(100% - 48px)`,
	},

	contentWrapper: {
		height: "100%",
		overflowY: "hidden",
		display: "flex",
		flexDirection: "column",
	},
}));

const MainContainer = ({ children, style, contentStyle }) => {
	const classes = useStyles();

	return (
		<Container className={classes.mainContainer} style={style}>
			<div className={classes.contentWrapper} style={contentStyle}>{children}</div>
		</Container>
	);
};

export default MainContainer;
